import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from "@sentry/angular";

Sentry.init({
    dsn: "https://859fd2ca77a5de27c9a2a070777fa4e6@o4510366364860416.ingest.us.sentry.io/4510366378295296",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
